const STATUS_OPTIONS_BY_BOOKING = {
  'Buchung Paket Test-only': [
    'Versand ED / 16personalities',
    'Auswertung ED & Versand an Kandidaten',
    'Versand Rechnung',
    'Zahlungseingang',
    'Paket Test-only abgeschlossen'
  ],
  'Buchung Paket Basic': [
    'Versand ED / 16personalities',
    'Auswertung ED & Versand an Kandidaten',
    'Terminierung Gespräch ED / Positionierung, Markenprofil',
    'Gespräch ED / Positionierung, Markenprofil',
    'Auswertung & Versand an Kandidaten Positionierung, Markenprofil',
    'Versand Rechnung',
    'Zahlungseingang',
    'Paket Basic abgeschlossen'
  ],
  'Buchung Paket Advanced': [
    'Versand ED / 16personalities',
    'Auswertung ED & Versand an Kandidaten',
    'Terminierung Gespräch ED / Positionierung, Markenprofil',
    'Gespräch ED / Positionierung, Markenprofil',
    'Auswertung & Versand an Kandidaten Positionierung, Markenprofil',
    'Terminierung Gespräch CV-Optimierung',
    'Gespräch CV-Optimierung',
    'Terminierung Gespräch LinkedIn-Optimierung',
    'Gespräch LinkedIn-Optimierung',
    'Auswertung & Versand an Kandidaten Zielfirmenliste und Positionen',
    'Versand Rechnung',
    'Zahlungseingang',
    'Paket Advanced abgeschlossen'
  ],
  'Buchung Paket Professional': [
    'Versand ED / 16personalities',
    'Auswertung ED & Versand an Kandidaten',
    'Terminierung Gespräch ED / Positionierung, Markenprofil',
    'Gespräch ED / Positionierung, Markenprofil',
    'Auswertung & Versand an Kandidaten Positionierung, Markenprofil',
    'Terminierung Gespräch CV-Optimierung',
    'Gespräch CV-Optimierung',
    'Terminierung Gespräch LinkedIn-Optimierung',
    'Gespräch LinkedIn-Optimierung',
    'Auswertung & Versand an Kandidaten Zielfirmenliste und Positionen',
    'Begleitgespräch #1',
    'Zusammenfassung Begleitgespräch #1',
    'Begleitgespräch #2',
    'Zusammenfassung Begleitgespräch #2',
    'Powerinterview',
    'Zusammenfassung Powerinterview',
    'Versand Rechnung',
    'Zahlungseingang',
    'Paket Professional abgeschlossen'
  ]
};

function getStatusOptionsForBooking(bookingValue) {
  return STATUS_OPTIONS_BY_BOOKING[bookingValue] || [];
}

function getStatusSearchOptions() {
  const alreadyAddedOptions = new Set();
  const options = [];
  Object.values(STATUS_OPTIONS_BY_BOOKING).forEach(packageOptions => {
    packageOptions.forEach(option => {
      if (!alreadyAddedOptions.has(option)) {
        alreadyAddedOptions.add(option);
        options.push({ value: option, label: option });
      }
    });
  });
  return options;
}

module.exports = { STATUS_OPTIONS_BY_BOOKING, getStatusOptionsForBooking, getStatusSearchOptions };
